(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/swish-cellphone/assets/swish-cellphone.js') >= 0) return;  svs.modules.push('/components/accountservices-react/swish-cellphone/assets/swish-cellphone.js');
'use strict';

const {
  MobileInput
} = svs.ui.reactFormInputs;
const {
  ReactButton: Button
} = svs.ui;

const SwishCellphone = _ref => {
  let {
    setNewCellphone,
    newCellphone = '',
    cellphone,
    isDeposit
  } = _ref;
  const [isShowInput, setIsShowInput] = React.useState(!cellphone);
  const handleChange = e => {
    let formattedNumber = e.target.value;
    if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
      formattedNumber = "0".concat(formattedNumber.slice(2));
    }
    if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
      formattedNumber = "0".concat(formattedNumber.slice(3));
    }
    if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
      formattedNumber = "0".concat(formattedNumber.slice(4));
    }
    setNewCellphone(formattedNumber);
  };
  React.useEffect(() => {
    if ((cellphone === null || cellphone === void 0 ? void 0 : cellphone.length) > 3) {
      setIsShowInput(false);
    }
  }, [cellphone]);
  return React.createElement("div", {
    className: "margin-v"
  }, !isShowInput && React.createElement("div", {
    className: "u-flex u-flex-align-items-end margin-top-2 margin-bottom"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, "Mobilnummer:", ' ', React.createElement("span", {
    className: "f-bold"
  }, cellphone)), React.createElement("div", null, React.createElement(Button, {
    onClick: () => setIsShowInput(true),
    size: 100,
    transparent: true
  }, "\xC4ndra"))), isShowInput && React.createElement("div", {
    className: "padding-top"
  }, React.createElement(MobileInput, {
    id: "newMobilePhoneNumber",
    infoMessage: "Nytt mobilnummer sparas med ".concat(isDeposit ? 'insättning' : 'uttag'),
    inputHelpText: "Mobilnummer",
    inputMode: "tel",
    isLessSpace: true,
    isRequired: true,
    label: "Ange nytt mobilnummer",
    name: "newmobile",
    onChange: handleChange,
    type: "text",
    value: newCellphone || ''
  })));
};
svs.accountservicesReact.swishCellphone.SwishCellphone = SwishCellphone;

 })(window);